import React, { useRef } from 'react';
import { motion, useReducedMotion, useScroll, useTransform } from 'framer-motion';
import { GlowFrame } from './GlowFrame';
const HERO_IMAGE = 'https://cdn.magicpatterns.com/uploads/kb6u8JdjiHaJsPN1tVNVE4/portal.jpg';
export function EventHero() {
  const sectionRef = useRef<HTMLElement>(null);
  const prefersReducedMotion = useReducedMotion();
  const {
    scrollYProgress
  } = useScroll({
    target: sectionRef,
    offset: ['start start', 'end start']
  });
  const scale = useTransform(scrollYProgress, [0, 1], [1, 1.12]);
  const opacity = useTransform(scrollYProgress, [0, 0.7, 1], [1, 1, 0]);
  const scrollTo = (href: string) => {
    document.querySelector(href)?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section id="top" ref={sectionRef} aria-label="The Doors of Perception" className="relative flex h-screen w-full flex-col justify-end overflow-hidden bg-ink" data-id="element-63" data-mp="1jywy70x5qd2v">
      <motion.div style={prefersReducedMotion ? undefined : {
      scale,
      opacity
    }} className="absolute inset-0" data-id="element-64" data-mp="19zo6yftofck7">
        <img src={HERO_IMAGE} alt="A dancer silhouetted before a tall glowing white LED portal, blue haze reflecting on the floor" className="h-full w-full object-cover object-center" data-id="element-65" data-mp="2d7i77yq7t77t" />
        <div className="pointer-events-none absolute inset-0" style={{
        background: 'radial-gradient(ellipse at center, transparent 42%, #05070A 94%)'
      }} aria-hidden="true" data-id="element-66" data-mp="29782sqi2mov2" />
        <div className="pointer-events-none absolute inset-x-0 top-0 h-36 bg-gradient-to-b from-ink to-transparent" aria-hidden="true" data-id="element-67" data-mp="30z77q2d6x1zu" />
        <div className="pointer-events-none absolute inset-x-0 bottom-0 h-56 bg-gradient-to-t from-ink to-transparent" aria-hidden="true" data-id="element-68" data-mp="2ry8zt8zmsabz" />
      </motion.div>

      <h1 className="pointer-events-none absolute inset-0 z-10 hidden items-center justify-between px-14 font-heading uppercase leading-[0.85] tracking-tight text-led lg:flex xl:px-20" data-id="element-69" data-mp="1bm283hr1rcyu">
        <span className="text-[5.5vw] [text-shadow:0_2px_28px_rgba(5,7,10,0.85)]" data-id="element-70" data-mp="wg68czn4lve8">The Doors</span>
        <span className="text-right text-[5.5vw] [text-shadow:0_2px_28px_rgba(5,7,10,0.85)]" data-id="element-71" data-mp="sg5vhjfods9a">
          Of Perception
        </span>
      </h1>

      <div className="relative z-10 flex flex-col items-center gap-6 px-5 pb-14 text-center sm:pb-16 lg:pb-20" data-id="element-72" data-mp="iq2uox2bba0e">
        <h2 className="font-heading text-[13vw] uppercase leading-[0.88] tracking-tight text-led [text-shadow:0_2px_28px_rgba(5,7,10,0.85)] sm:text-[9vw] lg:hidden" data-id="element-73" data-mp="dqq7gb7j40xa">
          The Doors of Perception
        </h2>
        <p className="max-w-xl text-[11px] uppercase tracking-[0.25em] text-led/70 sm:text-xs" data-id="element-74" data-mp="4qthm69ekw0n">
          A choreographic adaptation of Aldous Huxley&apos;s 1954 essay
        </p>
        <div className="flex flex-wrap items-center justify-center gap-4 pt-2" data-id="element-75" data-mp="1z4cfxib9cin0">
          <GlowFrame as="button" interactive onClick={() => scrollTo('#screening-room')} className="px-6 py-3 text-[11px] uppercase tracking-[0.2em] text-led sm:text-xs" data-id="element-76" data-mp="1u4zkwaa8g59c">
            Watch the work
          </GlowFrame>
          <GlowFrame as="button" interactive onClick={() => scrollTo('#contact')} className="px-6 py-3 text-[11px] uppercase tracking-[0.2em] text-led sm:text-xs" data-id="element-77" data-mp="26kzacqujmzjt">
            Bring it to your city
          </GlowFrame>
        </div>
      </div>
    </section>;
}